<p>azure-login works!</p>
